import { useEffect, useState, useContext } from "react";
import React from "react";
import { AuthContext } from "./context/AuthContext"; // Assuming you have an AuthContext

export default function BookingList() {
  const [bookings, setBookings] = useState([]);
  const { isAdmin } = useContext(AuthContext); // Assuming AuthContext provides isAdmin

  useEffect(() => {
    if (isAdmin) {
      fetch("https://darshan-uttrakhand-backend-anupdevops-projects.vercel.app/bookings")
        .then((res) => res.json())
        .then((data) => setBookings(data));
    }
  }, [isAdmin]);

  if (!isAdmin) {
    return (
    <div class="p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400" role="alert">
    <span class="font-medium">Access Denied!</span> You do not have permission to view this page. Please login with Admin Credentails to see booking details.
  </div>
  );
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Booking List</h2>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">Name</th>
            <th className="border p-2">Source</th>
            <th className="border p-2">Destination</th>
            <th className="border p-2">Date</th>
            <th className="border p-2">Time</th>
            <th className="border p-2">TaxiType</th>
            <th className="border p-2">Fare</th>
            <th className="border p-2">PhoneNumber</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((b) => (
            <tr key={b.id}>
              <td className="border p-2">{b.name}</td>
              <td className="border p-2">{b.pickup}</td>
              <td className="border p-2">{b.dropoff}</td>
              <td className="border p-2">{b.date}</td>
              <td className="border p-2">{b.time}</td>
              <td className="border p-2">{b.taxiType}</td>
              <td className="border p-2">{b.fare}</td>
              <td className="border p-2">{b.phone}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
